import { FC, useMemo } from "react";
import StarRateNewTrustScore from "../../../components/StarRate2.0";
import { fnRatingDisplay } from "../../../components/rateDisplay";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";

const LOGO_MARK = `${process.env.PUBLIC_URL}/images/logos/logo-mark.webp`;

const WidgetTemplate13: FC<IWidgetTemplate> = ({ company, score, theme }) => {
  const isDark = theme === "dark";
  const companyId = company?.companyId;

  const payload = useMemo(
    () => ({ companyId, widgetId: 8 as const }),
    [companyId],
  );

  const companyUrl = useMemo(
    () =>
      `https://www.trustfinance.com/companies/${companyId}?utm_source=widget&utm_medium=banner&utm_campaign=micro-star-vertical`,
    [companyId],
  );

  return (
    <div className="overflow-hidden d-flex justify-content-center fs-12">
      <a
        className="text-decoration-none"
        style={{ color: isDark ? "white" : "unset" }}
        href={companyUrl}
        target="_blank"
        rel="noreferrer noopener"
        id="Tooltip-1"
        onClick={() => ReachClick(payload)}
      >
        <div className="d-flex align-items-center flex-column">
          <div className="d-flex align-items-center gap-2">
            <b className={`d-none d-md-block${isDark ? " text-white" : ""}`}>
              {fnRatingDisplay(score?.score)}
            </b>
            <div className="d-flex align-items-center txt gap-1">
              <img src={LOGO_MARK} alt="TrustFinance" width={24} height={24} />
              <span className="fs-12">TrustFinance</span>
            </div>
          </div>
          <div className="fs-16 d-flex align-items-center p-2 fw-bold">
            <StarRateNewTrustScore value={score?.score} size={24} />
          </div>
          <div
            className={`text-center ${isDark ? "text-white" : "text-tfn-gray"}`}
          >
            TrusScore{" "}
            <b className={isDark ? "text-white" : "text-black"}>
              {score?.score}
            </b>{" "}
            |{" "}
            <b className={isDark ? "text-white" : "text-black"}>
              {score?.totalReview}
            </b>{" "}
            reviews
          </div>
        </div>
      </a>
    </div>
  );
};

export default WidgetTemplate13;
